/**
 * jQuery Tooltip v1.0
 * Copyright © 2018, Alexander Griffioen <mail@oscaralexander.com>
 * Published under MIT license.
 */

const pluginName = 'tooltip'

class Tooltip {
    constructor(el, options) {
        this.$el = $(el)
        this.options = $.extend({}, this.defaults, options)
        this.init()
    }

    init() {
        let timeout

        this.options.delay = this.$el.attr('data-tooltip-delay') || this.options.delay
        this.value = this.$el.attr('title') || this.$el.attr('data-tooltip')
        this.$el.removeAttr('title');

        if (this.value && this.value !== '') {
            // Create DOM element
            this.$tooltip = $('<div />').addClass(this.options.classNameTooltip).text(this.value)
            this.$tooltipArrow = $('<div />').addClass(this.options.classNameTooltipArrow)
            this.$tooltipArrow.appendTo(this.$tooltip)

            // Init event handlers
            this.$el.on({
                mouseover: (e) => {
                    timeout = setTimeout(() => this.onMouseOver(e), this.options.delay)
                },
                mouseout: (e) => { 
                    if (timeout) {
                        clearTimeout(timeout)    
                    }

                    this.onMouseOut(e)
                }
            })
        }
    }

    onMouseOut(e) {
        this.$tooltip.detach().remove()
    }

    onMouseOver(e) {
        let element
        let elementOffset
        let tooltip
        let viewportWidth

        // Append tooltip to DOM
        this.$tooltip.appendTo('body')

        // Set values
        elementOffset = this.$el.offset()
        element = {
            height: this.$el.outerHeight(),
            width: this.$el.outerWidth(),
            x: elementOffset.left,
            y: elementOffset.top
        }

        tooltip = {
            height: this.$tooltip.outerHeight(),
            width: this.$tooltip.outerWidth(),
            x: (element.x + (element.width * 0.5)) - (this.$tooltip.outerWidth() * 0.5),
            y: element.y - (this.$tooltip.outerHeight() + this.options.offsetY)
        }

        viewportWidth = $(window).width()

        // Set tooltip X position and width
        if ((tooltip.x + tooltip.width + this.options.clearance) > viewportWidth) {
            // Too wide for viewport
            if ((tooltip.width + (this.options.clearance * 2)) > viewportWidth) {
                // Resize and reposition
                tooltip.x = this.options.clearance
                tooltip.width = viewportWidth - (this.options.clearance * 2)
                this.$tooltip.css('width', tooltip.width)
                this.$tooltipArrow.css('left', (element.x + (element.width * 0.5)) - this.options.clearance)
            } else {
                // Reposition
                tooltip.x = viewportWidth - (tooltip.width + this.options.clearance)
                this.$tooltipArrow.css('left', (element.x + (element.width * 0.5)) - tooltip.x)
            }
        }

        if (tooltip.x < this.options.clearance) {
            tooltip.x = this.options.clearance
            this.$tooltipArrow.css('left', (element.x + (element.width * 0.5)) - this.options.clearance)
        }

        // Set Y position
        if ((element.y - (tooltip.height + this.options.offsetY + this.options.clearance)) < 0) {
            tooltip.y = (element.y + element.height + this.options.offsetY);
        }

        // Determine tooltip arrow position
        if (tooltip.y > element.y) {
            this.$tooltip.addClass(this.options.classNameTooltipBelow);
        }

        this.$tooltip
            .css({
                left: tooltip.x,
                top: tooltip.y
            })
            .addClass(this.options.classNameVisible)
    }

    setValue(value) {
        this.$tooltip.find(`.${this.options.classNameTooltip}`).text(value)
        this.value = value
    }
}

Tooltip.prototype.defaults = {
    classNameTooltip: 'tooltip',
    classNameTooltipArrow: 'tooltip-arrow',
    classNameTooltipBelow: 'is-below',
    classNameVisible: 'is-visible',
    clearance: 8,
    delay: 0,
    offsetY: 6,
}

$.fn[pluginName] = function (options) {
    return this.each(function () {
        let instance = $(this).data(`plugin_${pluginName}`)

        if (!instance) {
            $(this).data(`plugin_${pluginName}`, new Tooltip(this, options))
        } else {
            if (typeof options === 'string') {
                instance[options]()
            }
        }
    })
}